module.exports = __webpack_public_path__ + "img/08.3fb736a9.jpg";